export const ROUTES = {
  CALLBACK_DRIVER: '/callback/driver',
  INDEX: '/',
  NOTIFICATION_DISPLAY: '/notification/external-display',
  NOTIFICATION_STORAGE: '/notification/external-storage',
  REGISTRATION: (slugs: { registrationId: string }): string =>
    `/registration/${slugs.registrationId}`,
  REGISTRATION_ROOM_CODE: (slugs: {
    registrationId: string;
    roomCode: string;
  }): string => `/registration/${slugs.registrationId}/${slugs.roomCode}`,
  REGISTRATION_ROOM_CODE_CHECK: (slugs: {
    registrationId: string;
    roomCode: string;
  }): string => `/registration/${slugs.registrationId}/${slugs.roomCode}/check`,
  REGISTRATION_ROOM_CODE_EOS: (slugs: {
    registrationId: string;
    roomCode: string;
  }): string => `/registration/${slugs.registrationId}/${slugs.roomCode}/eos`,
  REGISTRATION_ROOM_CODE_INFO: (slugs: {
    registrationId: string;
    roomCode: string;
  }): string => `/registration/${slugs.registrationId}/${slugs.roomCode}/info`,
  REGISTRATION_ROOM_CODE_LAUNCH: (slugs: {
    registrationId: string;
    roomCode: string;
  }): string =>
    `/registration/${slugs.registrationId}/${slugs.roomCode}/launch`,
  REGISTRATION_ROOM_CODE_STATEMENTS: (slugs: {
    registrationId: string;
    roomCode: string;
  }): string =>
    `/registration/${slugs.registrationId}/${slugs.roomCode}/statements`,
  SANDBOX: '/sandbox',
  SIGNIN: '/signin',
  SIGNOUT: '/signout',
  STAFF: '/staff',
  STAFF_TEST_CENTER: (slugs: { testCenterId: string }): string =>
    `/staff/${slugs.testCenterId}`,
  STAFF_TEST_CENTER_INSTRUCTIONS: (slugs: { testCenterId: string }): string =>
    `/staff/${slugs.testCenterId}/instructions`,
  STAFF_TEST_CENTER_REGISTER: (slugs: { testCenterId: string }): string =>
    `/staff/${slugs.testCenterId}/register`,
  STAFF_TEST_CENTER_UNREGISTER: (slugs: { testCenterId: string }): string =>
    `/staff/${slugs.testCenterId}/unregister`,
};

export const BASE_64_REGEX =
  '(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)?';
export const ID_REGEX = '[0-9]+';
export const ROOM_CODE_REGEX = '[-0-9a-zA-Z]+';

export const ROUTES_REGEX = {
  CALLBACK_DRIVER: '\\/callback\\/driver',
  INDEX: '\\/',
  NOTIFICATION_DISPLAY: '\\/notification\\/external-display',
  NOTIFICATION_STORAGE: '\\/notification\\/external-storage',
  REGISTRATION: `\\/registration\\/${ID_REGEX}`,
  REGISTRATION_ROOM_CODE: `\\/registration\\/${ID_REGEX}\\/${ROOM_CODE_REGEX}`,
  REGISTRATION_ROOM_CODE_CHECK: `\\/registration\\/${ID_REGEX}\\/${ROOM_CODE_REGEX}/check`,
  REGISTRATION_ROOM_CODE_EOS: `\\/registration\\/${ID_REGEX}\\/${ROOM_CODE_REGEX}/eos`,
  REGISTRATION_ROOM_CODE_INFO: `\\/registration\\/${ID_REGEX}\\/${ROOM_CODE_REGEX}/info`,
  REGISTRATION_ROOM_CODE_LAUNCH: `\\/registration\\/${ID_REGEX}\\/${ROOM_CODE_REGEX}/launch`,
  REGISTRATION_ROOM_CODE_STATEMENTS: `\\/registration\\/${ID_REGEX}\\/${ROOM_CODE_REGEX}/statements`,
  SANDBOX: '\\/sandbox',
  SIGNIN: '\\/signin',
  SIGNOUT: '\\/signout',
  STAFF: '\\/staff',
  STAFF_TEST_CENTER: `\\/staff\\/${ID_REGEX}`,
  STAFF_TEST_CENTER_INSTRUCTIONS: `\\/staff\\/${ID_REGEX}\\/instructions`,
  STAFF_TEST_CENTER_REGISTER: `\\/staff\\/${ID_REGEX}\\/register`,
  STAFF_TEST_CENTER_UNREGISTER: `\\/staff\\/${ID_REGEX}\\/unregister`,
};

export const ROUTES_DESCRIPTION = {
  INDEX: 'Home Page',
  REGISTRATION: `Registration Page`,
  REGISTRATION_ROOM_CODE: `Registration Room Code Page`,
  REGISTRATION_ROOM_CODE_CHECK: `Device Check Page`,
  REGISTRATION_ROOM_CODE_EOS: `E O S Page`,
  REGISTRATION_ROOM_CODE_INFO: `Test Center and User Information Page`,
  REGISTRATION_ROOM_CODE_LAUNCH: `Launch Test Page`,
  REGISTRATION_ROOM_CODE_STATEMENTS: `Examinee Statements Page`,
  SIGNIN: 'A C T Unity Sign In Page',
  SIGNOUT: 'Sign Out',
  STAFF: 'Test Center Sign In Page',
  STAFF_TEST_CENTER: `Test Center Home Page`,
  STAFF_TEST_CENTER_INSTRUCTIONS: `Test Center Instructions Page`,
  STAFF_TEST_CENTER_REGISTER: `Test Center Registration Page`,
  STAFF_TEST_CENTER_UNREGISTER: `Test Center Unregister Page`,
};
